import { Component, HostListener, ViewChild } from '@angular/core';
import { SiaTranslatePipe } from '@sia/shared';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import {
  DxiColumnModule,
  DxoColumnChooserModule,
  DxoEditingModule,
  DxoFilterRowModule,
  DxoGroupPanelModule,
  DxoGroupingModule,
  DxoHeaderFilterModule,
  DxoLoadPanelModule,
  DxoRemoteOperationsModule,
  DxoScrollingModule,
  DxoSearchPanelModule,
  DxoSelectionModule,
  DxoSortingModule,
} from 'devextreme-angular/ui/nested';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';

@Component({
  selector: 'sia-grid-config-validation',
  templateUrl: './sia-grid-config-validation.component.html',
  styleUrls: ['./sia-grid-config-validation.component.scss'],
  providers: [
    {
      provide: SiaGridConfigTab,
      useExisting: SiaGridConfigValidationComponent,
    },
  ],
  standalone: true,
  imports: [
    DxDataGridModule,
    DxiColumnModule,
    DxoEditingModule,
    DxoSelectionModule,
    DxoRemoteOperationsModule,
    DxoSortingModule,
    DxoColumnChooserModule,
    DxoLoadPanelModule,
    DxoHeaderFilterModule,
    DxoFilterRowModule,
    DxoSearchPanelModule,
    DxoGroupPanelModule,
    DxoGroupingModule,
    DxoScrollingModule,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigValidationComponent extends SiaGridConfigTab {
  @ViewChild(DxDataGridComponent, { static: false })
  childDataGrid: DxDataGridComponent | undefined;

  @HostListener('window:unload')
  ngOnDestroy() {
    this.destroyDxComponent(this.childDataGrid, 'gridConfigValidation');
    super.ngOnDestroy();
  }
}
